module.exports = __webpack_public_path__ + "img/mrn_history.ab9e38d8.svg";